import React, { Suspense, useRef } from "react";
import { connect } from "react-redux";

import { Canvas, useFrame } from "@react-three/fiber";

import {
  Html,
  useTexture,
  useProgress,
  useMatcapTexture,
  PresentationControls,
  OrbitControls,
  ContactShadows,
  PerspectiveCamera,
} from "@react-three/drei";

import CircularProgress from "@mui/material/CircularProgress";

// specifiche
import { wrapTex, wrapCont } from "./specifiche";

// abbottonatura
import Abbottonatura from "../../Modelli/abbottonatura";

// corpo e vestibilità
import CorpoSlimRound from "../../Modelli/corpo_slim_round";
import CorpoSlimDritto from "../../Modelli/corpo_slim_dritto";
import CorpoRegularRound from "../../Modelli/corpo_regular_round";
import CorpoRegularDritto from "../../Modelli/corpo_regular_dritto";
import CorpoLargeRound from "../../Modelli/corpo_large_round";
import CorpoLargeDritto from "../../Modelli/corpo_large_dritto";

// maniche
import ManicaLunga from "../../Modelli/manica_lunga";
import ManicaCorta from "../../Modelli/manica_corta";

// tasche
import TascaRound from "../../Modelli/tasche_round";
import TascaSmussata from "../../Modelli/tasche_smussate";
import TascaWestern from "../../Modelli/tasche_western";

// pinces
import PinceCentrale from "../../Modelli/pince_centrale";
import PinceLaterale from "../../Modelli/pince_laterale";

// etichetta
import Etichetta from "../../Modelli/etichetta";

// base colletti
import CollettoBassoBase from "../../Modelli/colletto_basso_base";
import CollettoAltoBase1 from "../../Modelli/colletto_alto_1btn_base";
import CollettoAltoBase2 from "../../Modelli/colletto_alto_2btn_base";

// colletti
import CollettoBassoItaliano from "../../Modelli/colletto_basso_italiano";
import CollettoBassoItalianoSemi from "../../Modelli/colletto_basso_italiano_semi";
import CollettoAltoItaliano from "../../Modelli/colletto_alto_italiano";
import CollettoAltoItalianoSemi from "../../Modelli/colletto_alto_italiano_semi";
import CollettoBassoFrancese from "../../Modelli/colletto_basso_francese";
import CollettoBassoFranceseSemi from "../../Modelli/colletto_basso_francese_semi";
import CollettoAltoFrancese from "../../Modelli/colletto_alto_francese";
import CollettoAltoFranceseSemi from "../../Modelli/colletto_alto_francese_semi";
import CollettoBassoButtonDownCorto from "../../Modelli/colletto_basso_button_down_corto";
import CollettoBassoButtonDownLungo from "../../Modelli/colletto_basso_button_down_lungo";
import CollettoAltoButtonDownCorto from "../../Modelli/colletto_alto_button_down_corto";
import CollettoAltoButtonDownLungo from "../../Modelli/colletto_alto_button_down_lungo";
import CollettoBassoLondon from "../../Modelli/colletto_basso_london";
import CollettoAltoLondon from "../../Modelli/colletto_alto_london";
import CollettoBassoDiplomatico from "../../Modelli/colletto_basso_diplomatico";
import CollettoAltoDiplomatico from "../../Modelli/colletto_alto_diplomatico";

// polsini
import PolsinoRound from "../../Modelli/polsino_round";
import PolsinoRound2 from "../../Modelli/polsino_round_2btn";
import PolsinoSmussato from "../../Modelli/polsino_smussato";
import PolsinoSmussato2 from "../../Modelli/polsino_smussato_2btn";
import PolsinoDritto from "../../Modelli/polsino_dritto";
import PolsinoDritto2 from "../../Modelli/polsino_dritto_2btn";
import PolsinoGemelliDoppio from "../../Modelli/polsino_gemelli_doppio";
import PolsinoGemelliRound from "../../Modelli/polsino_gemelli_round";
import PolsinoGemelliSmussato from "../../Modelli/polsino_gemelli_smussato";
import PolsinoGemelliDritto from "../../Modelli/polsino_gemelli_dritto";

// iniziali
import Monogram from "../../Modelli/monogram";

// contrasti
import ContrastoCollettoAlto from "../../Modelli/contrasto_colletto_alto";
import ContrastoCollettoBasso from "../../Modelli/contrasto_colletto_basso";
import ContrastoPolsinoGemelliDoppio from "../../Modelli/contrasto_polsino_gemelli_doppio";
import ContrastoPolsinoRound from "../../Modelli/contrasto_polsino_round";
import ContrastoPolsinoSmussato from "../../Modelli/contrasto_polsino_smussato";
import ContrastoPolsinoDritto from "../../Modelli/contrasto_polsino_dritto";

const Camicia = (props) => {
  const {
    tessuto,
    fondo,
    vesti,
    chiusura,
    taschino,
    pinces,
    asola,
    bottone,
    filo,
    manic,
    vista,
    baseColletto,
    colletto,
    clubColletto,
    polsino,
    clubPolsino,
    iniziali,
    contrasto,
    zoom,
  } = props;

  // seleziona punto di vista
  let puntoVista = 0;
  switch (vista) {
    case 0:
      puntoVista = 0;
      break;
    case 1:
      puntoVista = Math.PI / 2;
      break;
    case 2:
      puntoVista = Math.PI;
      break;
    default:
      puntoVista = 0;
  }

  const Content = () => {
    // preload bottoni
    const [
      bottone_0,
      bottone_1,
      bottone_2,
      bottone_3,
      bottone_4,
      bottone_5,
      bottone_6,
      bottone_7,
      bottone_8,
      bottone_9,
      bottone_10,
      bottone_11,
      bottone_12,
      bottone_13,
      bottone_14,
      bottone_15,
      bottone_16,
    ] = useTexture([
      "/bottoni/0.png",
      "/bottoni/1.png",
      "/bottoni/2.png",
      "/bottoni/3.png",
      "/bottoni/4.png",
      "/bottoni/5.png",
      "/bottoni/6.png",
      "/bottoni/7.png",
      "/bottoni/8.png",
      "/bottoni/9.png",
      "/bottoni/10.png",
      "/bottoni/11.png",
      "/bottoni/12.png",
      "/bottoni/13.png",
      "/bottoni/14.png",
      "/bottoni/15.png",
      "/bottoni/16.png",
    ]);

    const [texture2] = useMatcapTexture(("texture index", 433), 1024); //287 //509
    const [texture, texture_1, texture_2, texture_3, eti] = useTexture([
      "/tessuti/" + tessuto + ".jpg",
      "/contrasti/1.jpg",
      "/contrasti/2.jpg",
      "/contrasti/3.jpg",
      "/label.jpg",
    ]);

    texture.repeat = {
      x: wrapTex[tessuto].repeat_x,
      y: wrapTex[tessuto].repeat_y,
      //rotation: 45,
    };
    texture.wrapS = 1024;
    texture.wrapT = 1024;

    texture.flipY = false;

    /*
    texture_colletti.repeat = {
      x: wrapTex[tessuto].repeat_x + (70 / 100),
      y: wrapTex[tessuto].repeat_y + (70 / 100),
      //rotation: 45,
    };
  

    texture_colletti.wrapS = 1024;
    texture_colletti.wrapT = 1024;

    texture_colletti.flipY = false;
    */

    texture_1.repeat = {
      x: wrapCont["1"].repeat_x,
      y: wrapCont["1"].repeat_y,
    };
    texture_1.wrapS = 1024;
    texture_1.wrapT = 1024;

    texture_2.repeat = {
      x: wrapCont["2"].repeat_x,
      y: wrapCont["2"].repeat_y,
    };
    texture_2.wrapS = 1024;
    texture_2.wrapT = 1024;

    texture_3.repeat = {
      x: wrapCont["3"].repeat_x,
      y: wrapCont["3"].repeat_y,
    };
    texture_3.wrapS = 1024;
    texture_3.wrapT = 1024;

    eti.flipY = false;

    // seleziona fit e fondo
    let corpo = <CorpoSlimRound tessuto={texture} />;
    if (vesti === "Slim" && fondo === 0) {
      corpo = <CorpoSlimRound tessuto={texture} />;
    } else if (vesti === "Slim" && fondo === 1) {
      corpo = <CorpoSlimDritto tessuto={texture} />;
    } else if (vesti === "Regular" && fondo === 0) {
      corpo = <CorpoRegularRound tessuto={texture} />;
    } else if (vesti === "Regular" && fondo === 1) {
      corpo = <CorpoRegularDritto tessuto={texture} />;
    } else if (vesti === "Large" && fondo === 0) {
      corpo = <CorpoLargeRound tessuto={texture} />;
    } else if (vesti === "Large" && fondo === 1) {
      corpo = <CorpoLargeDritto tessuto={texture} />;
    }

    // contrasti
    let texture1 = texture_1;
    switch (contrasto) {
      case 1:
        texture1 = texture_1;
        break;
      case 2:
        texture1 = texture_2;
        break;
      case 3:
        texture1 = texture_3;
        break;
      default:
        texture1 = texture_1;
    }

    // colore bottoni
    let coloreBottone = "#ffffff";
    let colBottone = bottone_0;
    switch (bottone) {
      case 0:
        colBottone = bottone_0;
        break;
      case 1:
        colBottone = bottone_1;
        break;
      case 2:
        colBottone = bottone_2;
        break;
      case 3:
        colBottone = bottone_3;
        break;
      case 4:
        colBottone = bottone_4;
        break;
      case 5:
        colBottone = bottone_5;
        break;
      case 6:
        colBottone = bottone_6;
        break;
      case 7:
        colBottone = bottone_7;
        break;
      case 8:
        colBottone = bottone_8;
        break;
      case 9:
        colBottone = bottone_9;
        break;
      case 10:
        colBottone = bottone_10;
        break;
      case 11:
        colBottone = bottone_11;
        break;
      case 12:
        colBottone = bottone_12;
        break;
      case 13:
        colBottone = bottone_13;
        break;
      case 14:
        colBottone = bottone_14;
        break;
      case 15:
        colBottone = bottone_15;
        break;
      case 16:
        colBottone = bottone_16;
        break;
      default:
        colBottone = bottone_0;
    }

    // colore asole
    let coloreAsola = "#f5f5f5";
    let opaAsola = 0.5;
    switch (asola) {
      case -1:
        coloreAsola = "#f5f5f5";
        opaAsola = 0.5;
        break;
      case 0:
        coloreAsola = "#f5f5f5";
        opaAsola = 1;
        break;
      case 1:
        coloreAsola = "#3273dc";
        opaAsola = 1;
        break;
      case 2:
        coloreAsola = "#3298dc";
        opaAsola = 1;
        break;
      case 3:
        coloreAsola = "#7a7a7a";
        opaAsola = 1;
        break;
      case 4:
        coloreAsola = "#121212";
        opaAsola = 1;
        break;
      case 5:
        coloreAsola = "#f14668";
        opaAsola = 1;
        break;
      case 6:
        coloreAsola = "#ff8c00";
        opaAsola = 1;
        break;
      case 7:
        coloreAsola = "#008000";
        opaAsola = 1;
        break;
      case 8:
        coloreAsola = "#fd788b";
        opaAsola = 1;
        break;
      default:
        coloreAsola = "#f5f5f5";
        opaAsola = 0.5;
    }

    // colore fili
    let coloreFilo = "#f5f5f5";
    switch (filo) {
      case -1:
        coloreFilo = "#f5f5f5";
        break;
      case 0:
        coloreFilo = "#ffffff";
        break;
      case 1:
        coloreFilo = "#3273dc";
        break;
      case 2:
        coloreFilo = "#3298dc";
        break;
      case 3:
        coloreFilo = "#7a7a7a";
        break;
      case 4:
        coloreFilo = "#121212";
        break;
      case 5:
        coloreFilo = "#f14668";
        break;
      case 6:
        coloreFilo = "#ff8c00";
        break;
      case 7:
        coloreFilo = "#008000";
        break;
      case 8:
        coloreFilo = "#fd788b";
        break;
      default:
        coloreFilo = "#f5f5f5";
    }

    // seleziona tipo manica
    let manica =
      manic === 0 ? (
        <ManicaLunga
          tessuto={texture}
          asole={coloreAsola}
          opa={opaAsola}
          bottoni={coloreBottone}
          matBottone={texture2}
          fili={coloreFilo}
          bottone={colBottone}
        />
      ) : (
        <ManicaCorta tessuto={texture} />
      );

    // seleziona abbottonatura
    let abbot = (
      <Abbottonatura
        chiusura={chiusura}
        tessuto={texture}
        asole={coloreAsola}
        opa={opaAsola}
        matBottone={texture2}
        bottoni={coloreBottone}
        fili={coloreFilo}
        bottone={colBottone}
      />
    );

    //seleziona taschino
    let tasca = null;
    switch (taschino) {
      case 0:
        tasca = null;
        break;
      case 1:
        tasca = (
          <TascaRound
            tasche={1}
            chiusura={false}
            pattina={false}
            tessuto={texture}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            bottone={colBottone}
          />
        );
        break;
      case 2:
        tasca = (
          <TascaRound
            tasche={1}
            chiusura={true}
            pattina={false}
            tessuto={texture}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            bottone={colBottone}
          />
        );
        break;
      case 3:
        tasca = (
          <TascaRound
            tasche={1}
            chiusura={true}
            pattina={true}
            tessuto={texture}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            bottone={colBottone}
          />
        );
        break;
      case 4:
        tasca = (
          <TascaRound
            tasche={2}
            chiusura={false}
            pattina={false}
            tessuto={texture}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            bottone={colBottone}
          />
        );
        break;
      case 5:
        tasca = (
          <TascaRound
            tasche={2}
            chiusura={true}
            pattina={false}
            tessuto={texture}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            bottone={colBottone}
          />
        );
        break;
      case 6:
        tasca = (
          <TascaRound
            tasche={2}
            chiusura={true}
            pattina={true}
            tessuto={texture}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            bottone={colBottone}
          />
        );
        break;
      case 7:
        tasca = (
          <TascaSmussata
            tasche={1}
            chiusura={false}
            pattina={false}
            tessuto={texture}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            bottone={colBottone}
          />
        );
        break;
      case 8:
        tasca = (
          <TascaSmussata
            tasche={1}
            chiusura={true}
            pattina={false}
            tessuto={texture}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            bottone={colBottone}
          />
        );
        break;
      case 9:
        tasca = (
          <TascaSmussata
            tasche={1}
            chiusura={true}
            pattina={true}
            tessuto={texture}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            bottone={colBottone}
          />
        );
        break;
      case 10:
        tasca = (
          <TascaSmussata
            tasche={2}
            chiusura={false}
            pattina={false}
            tessuto={texture}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            bottone={colBottone}
          />
        );
        break;
      case 11:
        tasca = (
          <TascaSmussata
            tasche={2}
            chiusura={true}
            pattina={false}
            tessuto={texture}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            bottone={colBottone}
          />
        );
        break;
      case 12:
        tasca = (
          <TascaSmussata
            tasche={2}
            chiusura={true}
            pattina={true}
            tessuto={texture}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            bottone={colBottone}
          />
        );
        break;
      case 13:
        tasca = (
          <TascaWestern
            tasche={1}
            chiusura={false}
            pattina={false}
            tessuto={texture}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            bottone={colBottone}
          />
        );
        break;
      case 14:
        tasca = (
          <TascaWestern
            tasche={1}
            chiusura={true}
            pattina={false}
            tessuto={texture}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            bottone={colBottone}
          />
        );
        break;
      case 15:
        tasca = (
          <TascaWestern
            tasche={1}
            chiusura={true}
            pattina={true}
            tessuto={texture}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            bottone={colBottone}
          />
        );
        break;
      case 16:
        tasca = (
          <TascaWestern
            tasche={2}
            chiusura={false}
            pattina={false}
            tessuto={texture}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            bottone={colBottone}
          />
        );
        break;
      case 17:
        tasca = (
          <TascaWestern
            tasche={2}
            chiusura={true}
            pattina={false}
            tessuto={texture}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            bottone={colBottone}
          />
        );
        break;
      case 18:
        tasca = (
          <TascaWestern
            tasche={2}
            chiusura={true}
            pattina={true}
            tessuto={texture}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            bottone={colBottone}
          />
        );
        break;

      default:
        tasca = null;
    }

    // seleziona pinces
    let pince = null;
    switch (pinces) {
      case 0:
        pince = null;
        break;
      case 1:
        pince = <PinceCentrale tessuto={texture} />;
        break;
      case 2:
        pince = <PinceLaterale tessuto={texture} />;
        break;
      default:
        pince = null;
    }

    // stampa etichetta
    let label = <Etichetta tessuto={texture} label={eti} />;

    // seleziona base colletti
    let contrastoCollo = <ContrastoCollettoBasso tessuto={texture1} />;
    let baseCollo = (
      <CollettoBassoBase
        tessuto={texture}
        asole={coloreAsola}
        opa={opaAsola}
        matBottone={texture2}
        bottoni={coloreBottone}
        fili={coloreFilo}
        club={clubColletto}
        bottone={colBottone}
      />
    );
    switch (baseColletto) {
      case 0:
        baseCollo = (
          <CollettoBassoBase
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
        contrastoCollo = <ContrastoCollettoBasso tessuto={texture1} />;
        break;
      case 1:
        baseCollo = (
          <CollettoAltoBase1
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
        contrastoCollo = <ContrastoCollettoAlto tessuto={texture1} />;
        break;
      case 2:
        baseCollo = (
          <CollettoAltoBase2
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
        contrastoCollo = <ContrastoCollettoAlto tessuto={texture1} />;
        break;
      default:
        baseCollo = (
          <CollettoBassoBase
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
        contrastoCollo = <ContrastoCollettoBasso tessuto={texture1} />;
    }

    // seleziona vele colletti
    let collo = (
      <CollettoAltoButtonDownCorto
        tessuto={texture}
        asole={coloreAsola}
        opa={opaAsola}
        matBottone={texture2}
        bottoni={coloreBottone}
        fili={coloreFilo}
        club={clubColletto}
        bottone={colBottone}
      />
    );
    switch (colletto) {
      case 0:
        collo = (
          <CollettoAltoButtonDownCorto
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
        break;
      case 1:
        collo = (
          <CollettoAltoButtonDownCorto
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
        break;
      case 2:
        collo = (
          <CollettoAltoButtonDownCorto
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
        break;
      case 3:
        collo = (
          <CollettoAltoButtonDownCorto
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
        break;
      case 4:
        collo = (
          <CollettoAltoButtonDownCorto
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
        break;
      case 5:
        collo = (
          <CollettoAltoButtonDownCorto
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
        break;
      case 6:
        collo = <CollettoAltoFrancese tessuto={texture} club={clubColletto} />;
        break;
      case 7:
        collo = <CollettoAltoItaliano tessuto={texture} club={clubColletto} />;
        break;
      case 8:
        collo = <CollettoAltoItaliano tessuto={texture} club={clubColletto} />;
        break;
      case 9:
        collo = (
          <CollettoAltoItalianoSemi tessuto={texture} club={clubColletto} />
        );
        break;
      case 10:
        collo = (
          <CollettoAltoItalianoSemi tessuto={texture} club={clubColletto} />
        );
        break;
      case 11:
        collo = <CollettoAltoFrancese tessuto={texture} club={clubColletto} />;
        break;
      case 12:
        collo = <CollettoAltoFrancese tessuto={texture} club={clubColletto} />;
        break;
      case 13:
        collo = <CollettoAltoFrancese tessuto={texture} club={clubColletto} />;
        break;
      case 14:
        collo = <CollettoAltoItaliano tessuto={texture} club={clubColletto} />;
        break;

      case 15:
        collo = (
          <CollettoAltoItalianoSemi tessuto={texture} club={clubColletto} />
        );
        break;
      case 16:
        collo = (
          <CollettoAltoFranceseSemi tessuto={texture} club={clubColletto} />
        );
        break;
      case 17:
        collo = (
          <CollettoAltoFranceseSemi tessuto={texture} club={clubColletto} />
        );
        break;

      case 18:
        collo = <CollettoAltoLondon tessuto={texture} club={clubColletto} />;
        break;
      case 19:
        collo = <CollettoAltoFrancese tessuto={texture} club={clubColletto} />;
        break;
      case 20:
        collo = <CollettoAltoFrancese tessuto={texture} club={clubColletto} />;
        break;

      case 21:
        collo = <CollettoAltoItaliano tessuto={texture} club={clubColletto} />;
        break;

      case 22:
        collo = (
          <CollettoAltoButtonDownCorto
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
        break;
      case 23:
        collo = (
          <CollettoAltoButtonDownCorto
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
        break;
      case 24:
        collo = (
          <CollettoAltoButtonDownCorto
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
        break;

      case 25:
        collo = (
          <CollettoBassoButtonDownCorto
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
        break;
      case 26:
        collo = (
          <CollettoBassoButtonDownCorto
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
        break;
      case 27:
        collo = (
          <CollettoBassoButtonDownCorto
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
        break;

      case 28:
        collo = (
          <CollettoBassoItalianoSemi tessuto={texture} club={clubColletto} />
        );
        break;
      case 29:
        collo = (
          <CollettoBassoItalianoSemi tessuto={texture} club={clubColletto} />
        );
        break;
      case 30:
        collo = (
          <CollettoBassoItalianoSemi tessuto={texture} club={clubColletto} />
        );
        break;

      default:
        collo = (
          <CollettoAltoButtonDownCorto
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
    }

    /* seleziona vele colletti
    let collo = <CollettoBassoItaliano tessuto={texture} club={clubColletto} />;
    switch (colletto) {
      case 0:
        collo = <CollettoBassoItaliano tessuto={texture} club={clubColletto} />;
        break;
      case 1:
        collo = <CollettoAltoItaliano tessuto={texture} club={clubColletto} />;
        break;
      case 2:
        collo = <CollettoAltoItaliano tessuto={texture} club={clubColletto} />;
        break;
      case 3:
        collo = (
          <CollettoBassoItalianoSemi tessuto={texture} club={clubColletto} />
        );
        break;
      case 4:
        collo = (
          <CollettoAltoItalianoSemi tessuto={texture} club={clubColletto} />
        );
        break;
      case 5:
        collo = (
          <CollettoAltoItalianoSemi tessuto={texture} club={clubColletto} />
        );
        break;
      case 6:
        collo = <CollettoBassoFrancese tessuto={texture} club={clubColletto} />;
        break;
      case 7:
        collo = <CollettoAltoFrancese tessuto={texture} club={clubColletto} />;
        break;
      case 8:
        collo = <CollettoAltoFrancese tessuto={texture} club={clubColletto} />;
        break;
      case 9:
        collo = (
          <CollettoBassoFranceseSemi tessuto={texture} club={clubColletto} />
        );
        break;
      case 10:
        collo = (
          <CollettoAltoFranceseSemi tessuto={texture} club={clubColletto} />
        );
        break;
      case 11:
        collo = (
          <CollettoAltoFranceseSemi tessuto={texture} club={clubColletto} />
        );
        break;
      case 12:
        collo = (
          <CollettoBassoButtonDownCorto
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
        break;
      case 13:
        collo = (
          <CollettoAltoButtonDownCorto
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
        break;
      case 14:
        collo = (
          <CollettoAltoButtonDownCorto
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
        break;
      case 15:
        collo = (
          <CollettoBassoButtonDownLungo
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
        break;
      case 16:
        collo = (
          <CollettoAltoButtonDownLungo
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
        break;
      case 17:
        collo = (
          <CollettoAltoButtonDownLungo
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubColletto}
            bottone={colBottone}
          />
        );
        break;
      case 18:
        collo = <CollettoBassoLondon tessuto={texture} club={clubColletto} />;
        break;
      case 19:
        collo = <CollettoAltoLondon tessuto={texture} club={clubColletto} />;
        break;
      case 20:
        collo = <CollettoAltoLondon tessuto={texture} club={clubColletto} />;
        break;
      case 21:
        collo = (
          <CollettoBassoDiplomatico tessuto={texture} club={clubColletto} />
        );
        break;
      case 22:
        collo = (
          <CollettoAltoDiplomatico tessuto={texture} club={clubColletto} />
        );
        break;
      case 23:
        collo = (
          <CollettoAltoDiplomatico tessuto={texture} club={clubColletto} />
        );
        break;
      case 24:
        collo = null;
        break;
      case 25:
        collo = null;
        break;
      case 26:
        collo = null;
        break;
      default:
        collo = <CollettoBassoItaliano tessuto={texture} club={clubColletto} />;
    }

    */

    // seleziona polsini
    let polso = (
      <PolsinoSmussato
        tessuto={texture}
        asole={coloreAsola}
        opa={opaAsola}
        matBottone={texture2}
        bottoni={coloreBottone}
        fili={coloreFilo}
        club={clubPolsino}
        bottone={colBottone}
      />
    );
    let contrastoPolsino = <ContrastoPolsinoSmussato tessuto={texture1} />;
    switch (polsino) {
      case 0:
        polso = (
          <PolsinoSmussato
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubPolsino}
            bottone={colBottone}
          />
        );
        contrastoPolsino = <ContrastoPolsinoSmussato tessuto={texture1} />;
        break;
      case 1:
        polso = (
          <PolsinoSmussato2
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubPolsino}
            bottone={colBottone}
          />
        );
        contrastoPolsino = <ContrastoPolsinoSmussato tessuto={texture1} />;
        break;
      case 2:
        polso = (
          <PolsinoSmussato
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubPolsino}
            bottone={colBottone}
          />
        );
        contrastoPolsino = <ContrastoPolsinoSmussato tessuto={texture1} />;
        break;
      case 3:
        polso = (
          <PolsinoRound
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubPolsino}
            bottone={colBottone}
          />
        );
        contrastoPolsino = <ContrastoPolsinoRound tessuto={texture1} />;
        break;
      case 4:
        polso = (
          <PolsinoRound2
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubPolsino}
            bottone={colBottone}
          />
        );
        contrastoPolsino = <ContrastoPolsinoRound tessuto={texture1} />;
        break;
      case 5:
        polso = (
          <PolsinoGemelliSmussato
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubPolsino}
          />
        );
        contrastoPolsino = <ContrastoPolsinoSmussato tessuto={texture1} />;
        break;
      case 6:
        polso = (
          <PolsinoGemelliDoppio
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubPolsino}
          />
        );
        contrastoPolsino = <ContrastoPolsinoGemelliDoppio tessuto={texture1} />;
        break;
      case 7:
        polso = (
          <PolsinoGemelliRound
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubPolsino}
          />
        );
        contrastoPolsino = <ContrastoPolsinoRound tessuto={texture1} />;
        break;
      default:
        polso = (
          <PolsinoSmussato
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubPolsino}
            bottone={colBottone}
          />
        );
        contrastoPolsino = <ContrastoPolsinoSmussato tessuto={texture1} />;
    }

    /**





      case 0:
        polso = (
          <PolsinoRound
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubPolsino}
            bottone={colBottone}
          />
        );
        contrastoPolsino = <ContrastoPolsinoRound tessuto={texture1} />;
        break;
      case 1:
        polso = (
          <PolsinoRound2
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubPolsino}
            bottone={colBottone}
          />
        );
        contrastoPolsino = <ContrastoPolsinoRound tessuto={texture1} />;
        break;
      case 2:
        polso = (
          <PolsinoSmussato
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubPolsino}
            bottone={colBottone}
          />
        );
        contrastoPolsino = <ContrastoPolsinoSmussato tessuto={texture1} />;
        break;
      case 3:
        polso = (
          <PolsinoSmussato2
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubPolsino}
            bottone={colBottone}
          />
        );
        contrastoPolsino = <ContrastoPolsinoSmussato tessuto={texture1} />;
        break;
      case 4:
        polso = (
          <PolsinoDritto
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubPolsino}
            bottone={colBottone}
          />
        );
        contrastoPolsino = <ContrastoPolsinoDritto tessuto={texture1} />;
        break;
      case 5:
        polso = (
          <PolsinoDritto2
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubPolsino}
            bottone={colBottone}
          />
        );
        contrastoPolsino = <ContrastoPolsinoDritto tessuto={texture1} />;
        break;
      case 6:
        polso = (
          <PolsinoGemelliDoppio
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubPolsino}
          />
        );
        contrastoPolsino = <ContrastoPolsinoGemelliDoppio tessuto={texture1} />;
        break;
      case 7:
        polso = (
          <PolsinoGemelliRound
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubPolsino}
          />
        );
        contrastoPolsino = <ContrastoPolsinoRound tessuto={texture1} />;
        break;
      case 8:
        polso = (
          <PolsinoGemelliSmussato
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubPolsino}
          />
        );
        contrastoPolsino = <ContrastoPolsinoSmussato tessuto={texture1} />;
        break;
      case 9:
        polso = (
          <PolsinoGemelliDritto
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubPolsino}
          />
        );
        contrastoPolsino = <ContrastoPolsinoDritto tessuto={texture1} />;
        break;
      default:
        polso = (
          <PolsinoRound
            tessuto={texture}
            asole={coloreAsola}
            opa={opaAsola}
            matBottone={texture2}
            bottoni={coloreBottone}
            fili={coloreFilo}
            club={clubPolsino}
          />
        );
        contrastoPolsino = <ContrastoPolsinoRound tessuto={texture1} />;
    }
     */

    // set iniziali
    let monog = <Monogram iniziali={iniziali} />;

    const ref = useRef();
    useFrame((state) => {
      /* const t = state.clock.getElapsedTime();
      ref.current.rotation.y = Math.sin(t / 1.6) / 8;
      ref.current.position.y = (1 + Math.sin(t / 1.8)) / 20; */
    });

    return (
      <group
        ref={ref}
        rotation={[0, 0, 0]}
        scale={zoom ? [2.2, 2.2, 2.2] : [1, 1, 1]}
        position={zoom ? [0, -4.2, 0] : [0, 0, 0]}
      >
        {baseCollo}
        {contrasto > 0 ? contrastoCollo : null}
        {collo}
        {abbot}
        {corpo}
        {manica}
        {manic === 0 ? polso : null}
        {contrasto > 0 && manic === 0 ? contrastoPolsino : null}
        {tasca}
        {pince}
        {label}
        {monog}
      </group>
    );
  };

  return (
    <>
      {/*}
      <div id="canvas" className="container-viste is-hidden-touch">
        <Canvas
          invalidateFrameloop
          linear
          camera={{ position: [0, 0, 20], fov: 20 }}
          dpr={[1, 2]}
        >
          <ambientLight intensity={0.86} />
          <spotLight
            position={[10, 20, 20]}
            angle={0.35}
            penumbra={0.55}
            shadow-mapSize={[512, 512]}
            castShadow
            intensity={0.2}
          />
          <spotLight
            position={[-10, -20, -20]}
            angle={0.25}
            penumbra={0.55}
            shadow-mapSize={[512, 512]}
            castShadow
            intensity={0.2}
          />
          <Suspense fallback={<Loader />}>
            <PresentationControls
              snap
              zoom={1.2}
              rotation={[0, puntoVista, 0]} //o Math.PI(dietro)
              polar={[-Math.PI / 4, Math.PI / 4]}
              azimuth={[-Math.PI, Math.PI]}
            >
              <Content />
              <ContactShadows
                opacity={0.2}
                frames={1}
                position={[0, -3, 0]}
                scale={10}
                blur={4}
                far={10}
              />
            </PresentationControls>
          </Suspense>
        </Canvas>
      </div>
      */}

      <div id="canvas-mobile" className="container-viste">
        <Canvas
          invalidateFrameloop
          linear
          //camera={{ position: [0, 0, 80], fov: 50 }}
          dpr={[1, 2]}
        >
          <PerspectiveCamera
            makeDefault
            position={[Math.PI / -0.2, Math.PI / 0.8, Math.PI / 0.2]}
          />
          <ambientLight intensity={0.86} />
          <spotLight
            position={[10, 20, 20]}
            angle={0.35}
            penumbra={0.55}
            shadow-mapSize={[512, 512]}
            castShadow
            intensity={0.2}
          />
          <spotLight
            position={[-10, -20, -20]}
            angle={0.25}
            penumbra={0.55}
            shadow-mapSize={[512, 512]}
            castShadow
            intensity={0.2}
          />
          <Suspense fallback={<Loader />}>
            <Content />
            {/* <ContactShadows
              opacity={0.2}
              frames={1}
              position={[0, -3, 0]}
              scale={10}
              blur={4}
              far={10}
            /> */}
          </Suspense>
          <OrbitControls
            minPolarAngle={Math.PI / 3.5}
            maxPolarAngle={Math.PI / 1.5}
            minDistance={4}
            maxDistance={8}
          />
        </Canvas>
      </div>
    </>
  );
};

function Loader() {
  const { progress } = useProgress();
  return (
    <Html center>
      <CircularProgress variant="determinate" value={progress} />
    </Html>
  );
}

function mapStateToProps(state) {
  return {
    fondo: state.shop.camicia.fondo,
    vesti: state.shop.camicia.misure.fit,
    manic: state.shop.camicia.manica,
    chiusura: state.shop.camicia.chiusura,
    taschino: state.shop.camicia.taschino,
    pinces: state.shop.camicia.pince,
    asola: state.shop.camicia.asola,
    bottone: state.shop.camicia.bottone,
    filo: state.shop.camicia.filo,
    vista: state.shop.vista,
    baseColletto: state.shop.camicia.baseColletto,
    colletto: state.shop.camicia.colletto,
    clubColletto: state.shop.camicia.clubColletto,
    polsino: state.shop.camicia.polsino,
    clubPolsino: state.shop.camicia.clubPolsino,
    iniziali: state.shop.camicia.iniziali,
    contrasto: state.shop.camicia.contrasto,
    zoom: state.shop.zoom,
  };
}

export default connect(mapStateToProps)(Camicia);
